import { NUDGE_CATEGORIES, CATEGORY_METADATA } from '@duva/shared'

/** Category filter chips (library + admin) */
export const NUDGE_LIBRARY_CATEGORIES = ['all', ...NUDGE_CATEGORIES] as const

export type NudgeLibraryCategory = (typeof NUDGE_LIBRARY_CATEGORIES)[number]

/** Warm-tinted chips — ink text on soft fills. Derived from shared metadata tailwind classes. */
export const CATEGORY_COLORS: Record<string, string> = Object.entries(CATEGORY_METADATA).reduce(
  (acc, [cat, meta]) => ({
    ...acc,
    [cat]: meta.tailwind,
  }),
  {}
)
